// ====================================================================
// CLIENT FOLLOW-UP CRM - CONFIGURATION
// ====================================================================

function sanitizeSupabaseUrl(url) {
  if (!url) return '';
  let cleaned = url.trim();
  // Strip trailing slashes and '/rest/v1' path if present
  cleaned = cleaned.replace(/\/+$/, '');
  cleaned = cleaned.replace(/\/rest\/v1\/?$/, '');
  return cleaned;
}

const savedUrl = localStorage.getItem('crm_supabase_url');
const savedKey = localStorage.getItem('crm_supabase_key');

// Default credentials (if not set in localStorage)
const defaultUrl = 'https://nfnksxzxfwfbxkhtwrgi.supabase.co';
const defaultKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5mbmtzeHp4ZndmYnhraHR3cmdpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU0MzMxNTIsImV4cCI6MjEwMTAwOTE1Mn0.U90zou7vK0UJNWSY6HA6EQeFu9CrqUhOBeaGZMRmbKg';

export const SUPABASE_CONFIG = {
  url: sanitizeSupabaseUrl(savedUrl !== null ? savedUrl : defaultUrl),
  anonKey: (savedKey !== null ? savedKey : defaultKey).trim()
};

export function saveSupabaseConfig(url, anonKey) {
  const cleanUrl = sanitizeSupabaseUrl(url);
  localStorage.setItem('crm_supabase_url', cleanUrl);
  localStorage.setItem('crm_supabase_key', anonKey.trim());
  window.location.reload();
}

